var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PlusRoundedIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none"
  }, React.createElement("path", {
    d: "M11.1915 0.758043C20.2922 -0.252666 29.7089 -0.252696 38.8096 0.758043C44.1982 1.35587 48.5522 5.59475 49.1837 11.0071C50.2723 20.2995 50.2723 29.6901 49.1837 38.9934C48.5521 44.4055 44.1981 48.6327 38.8096 49.2414C29.7089 50.2522 20.2922 50.2522 11.1915 49.2414C5.80291 48.6437 1.44802 44.4056 0.816466 38.9934C-0.272155 29.6901 -0.272155 20.2995 0.816466 11.0071C1.44788 5.59467 5.8028 1.3558 11.1915 0.758043ZM38.3194 5.14867C29.5343 4.17054 20.455 4.17053 11.6807 5.14867C8.30614 5.51827 5.60686 8.18137 5.2149 11.5178C4.16984 20.4732 4.16987 29.5156 5.2149 38.4709C5.6068 41.8074 8.30611 44.4704 11.6807 44.8401C20.4659 45.8182 29.5451 45.8182 38.3194 44.8401C41.6941 44.4597 44.3943 41.7966 44.7862 38.4709C45.8312 29.5156 45.8313 20.4732 44.7862 11.5178C44.3943 8.18128 41.6941 5.51819 38.3194 5.14867ZM24.9952 10.301C26.2143 10.3012 27.2051 11.2899 27.2051 12.5071V22.7883H37.503C38.7221 22.7883 39.7128 23.7773 39.713 24.9944C39.713 26.2116 38.7222 27.2014 37.503 27.2014H27.2051V37.4827C27.205 38.6997 26.2142 39.6885 24.9952 39.6887C23.776 39.6887 22.7854 38.6998 22.7852 37.4827V27.2014H12.4864C11.2672 27.2013 10.2764 26.2116 10.2764 24.9944C10.2766 23.7773 11.2673 22.7884 12.4864 22.7883H22.7852V12.5071C22.7852 11.2898 23.7759 10.301 24.9952 10.301Z",
    fill: "black"
  })));
};
export var PlusRoundedIconGlyph = function (props) {
  return React.createElement(PlusRoundedIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};